import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=9bc3c132"
import script from "./FloatingChat.vue?vue&type=script&lang=js"
export * from "./FloatingChat.vue?vue&type=script&lang=js"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=9bc3c132&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports